export default __webpack_public_path__ + "static/media/sam-and-karen-soccer-game.3d5e7118.jpeg";